import { usePathname } from 'expo-router';
import {
  ONBOARDING,
  PROGRESS_TRACKER_FUNDING,
  VARO_ADVANCE,
} from 'shared/constants/onboarding';

type VaroAdvanceFlow =
  | typeof ONBOARDING
  | typeof VARO_ADVANCE
  | typeof PROGRESS_TRACKER_FUNDING;

const useVaroAdvanceFlow = (): VaroAdvanceFlow => {
  const pathname = usePathname();
  let flow: VaroAdvanceFlow = VARO_ADVANCE;

  if (pathname.startsWith('/onboarding')) {
    flow = ONBOARDING;
  } else if (pathname.startsWith('/progress-tracker-funding')) {
    flow = PROGRESS_TRACKER_FUNDING;
  }

  return flow;
};

export default useVaroAdvanceFlow;
